module.exports = __webpack_public_path__ + "static/42-271ccbb733d093ecdcc28685fd1ea5c3.png";